import { SAMPLE_NOTES_ATTACHMENTS } from './sampleNotesAttachments';
import type { AccountNoteAttachment } from './types';

// Same shape as the other Account list hooks, so wiring svc-contracting only replaces this body.
export function useAccountNotesAttachments(_accountId: string): {
  error: Error | null;
  isLoading: boolean;
  notesAttachments: ReadonlyArray<AccountNoteAttachment>;
} {
  return { error: null, isLoading: false, notesAttachments: SAMPLE_NOTES_ATTACHMENTS };
}
